<template>
    <td class="td" v-bind:class="classes">
        <div ref="wrapper" class="cell-menu">
            <a class="table-field-menu__link" @click="toggleMenu" style="cursor: pointer;">
                <span>{{values}}</span>
            </a>

            <div class="menu-wrapper" v-if="showLinkMenu" v-bind:style="{top: this.blockPosition.top + 'px'}">
                <span class="close-icon-wrapper">
                  <i class="close" @click="closeMenu()"></i>
                </span>
                <div class="menu">
                    <div v-for="value in cellValue">
                        {{value}}
                    </div>
                </div>
            </div>
        </div>
    </td>
</template>

<script>
    export default {
        name: "cctable-array-view",
        props: {
            cellValue: {
                type: Array,
                required: true
            },
            classes: {
                type: Array,
                required: false
            }
        },
        data(){
            return {
                showLinkMenu: false,
                blockPosition: {
                    top: null
                }
            }
        },
        computed: {
            values: function(){

                if (this.cellValue.length > 1)
                {
                    return this.cellValue[0] + '...';
                }
                else
                {
                    return this.cellValue.join(', ');
                }
            }
        },
        methods: {
            toggleMenu: function(){
                this.showLinkMenu = !this.showLinkMenu;

                let elementPosition = this.$refs.wrapper.getBoundingClientRect();

                this.blockPosition.top = elementPosition.top;
            },
            closeMenu: function(){
                this.showLinkMenu = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
    td {
        & > .cell-menu {
            width: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/table/cellViewTypesHandlers/CCTableArrayView.vue